export default __webpack_public_path__ + "locales/vi/FormGallery.json?hash=4be040f15d53c216ad73bad16035d02d";